import React from 'react'
import RefreshIcon from '@mui/icons-material/Refresh'

import Button from 'components/Form/Button'
import { ListSkeleton } from 'components/Skeleton'
import TableWrapper from 'components/TableWrapper'
import UserApprovalsTable from 'components/UserApprovalsTable'

import useController from './controller'
import {
  Count,
  HeaderActions,
  Page,
  PageEyebrow,
  PageHeader,
  PageIntro,
  PageSubtitle,
  PageTitle,
  State,
  StateText,
  StateTitle,
} from './styled'

export default function UserApprovals() {
  const {
    summary,
    canViewApprovals,
    loading,
    loaded,
    error,
    search,
    rowAction,
    t,
    retry,
    onSearchChange,
    onPageChange,
    onDecision,
    loadCompanyOptions,
    loadIdentityReview,
  } = useController()

  return (
    <Page>
      {!canViewApprovals ? (
        <ListSkeleton rows={6} />
      ) : (
        <>
          <PageHeader>
            <PageIntro>
              <PageEyebrow>{t('user_approvals_eyebrow')}</PageEyebrow>
              <PageTitle>{t('user_approvals_title')}</PageTitle>
              <PageSubtitle>{t('user_approvals_subtitle')}</PageSubtitle>
            </PageIntro>
            <HeaderActions>
              {!loaded || error ? null : (
                <Count>
                  <strong>{summary?.totalPending || 0}</strong>
                  <span>{t('user_approvals_pending_count')}</span>
                </Count>
              )}
              <Button
                color="blue"
                disabled={loading}
                nospace
                outline
                startIcon={<RefreshIcon />}
                width="fit-content"
                onClick={() => retry()}
              >
                {t('user_approvals_refresh')}
              </Button>
            </HeaderActions>
          </PageHeader>

          <TableWrapper
            title={t('user_approvals_pending_requests')}
            searchValue={search}
            searchPlaceholder={t('user_approvals_search_placeholder')}
            onSearchChange={onSearchChange}
          >
            {!loaded || (loading && !summary?.rows?.length) ? (
              <ListSkeleton rows={6} />
            ) : error ? (
              <State>
                <StateTitle>{t('user_approvals_unavailable')}</StateTitle>
                <StateText>{error}</StateText>
              </State>
            ) : summary?.rows?.length ? (
              <UserApprovalsTable
                rows={summary.rows}
                rowAction={rowAction}
                showStateColumn={summary.showStateColumn}
                showCepColumn={summary.showCepColumn}
                pagination={summary.pagination}
                onDecision={onDecision}
                loadCompanyOptions={loadCompanyOptions}
                loadIdentityReview={loadIdentityReview}
                onPageChange={onPageChange}
              />
            ) : (
              <State>
                <StateTitle>
                  {search
                    ? t('user_approvals_no_search_results')
                    : t('user_approvals_empty')}
                </StateTitle>
                <StateText>
                  {search
                    ? t('user_approvals_no_search_results_description')
                    : t('user_approvals_empty_description')}
                </StateText>
              </State>
            )}
          </TableWrapper>
        </>
      )}
    </Page>
  )
}
